import React, {Component} from 'react';
import PropTypes from 'prop-types';
import dayjs from 'utils/dayjs';
import {Button} from '@spothero/ui-backlog';
import {Box} from '@spothero/ui';
import DateUtils from 'utils/date';
import CancellationInfo from 'common/cancellation-info';
import Card from 'common/card';
import PaymentMethodsIcons from 'common/payment-methods-icons';
import Price from 'common/price';
import AvailableInventory from '../available-inventory-message';

export default class AirportPurchaseInformation extends Component {
    static propTypes = {
        facility: PropTypes.object,
        isFetchingRates: PropTypes.bool,
        starts: PropTypes.string,
        ends: PropTypes.string,
        availableTransientInventory: PropTypes.number,
        selectedRate: PropTypes.object,
        onCheckoutClick: PropTypes.func,
        displayPrice: PropTypes.number,
        currencyType: PropTypes.string,
        onShowConfirmDateTimeModal: PropTypes.func,
    };

    constructor(props) {
        super(props);

        const {isFetchingRates} = props;

        this.state = {
            prevIsFetchingRates: isFetchingRates,
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const {isFetchingRates} = nextProps;

        if (prevState.prevIsFetchingRates && !isFetchingRates) {
            return {
                prevIsFetchingRates: isFetchingRates,
            };
        }

        return null;
    }

    _onDateTimeEditClick = () => {
        const {onShowConfirmDateTimeModal} = this.props;

        onShowConfirmDateTimeModal(true);
    };

    render() {
        const {
            facility: {cancellation_allowed: cancellationAllowed},
            starts,
            ends,
            selectedRate,
            availableTransientInventory,
            onCheckoutClick,
            displayPrice,
            currencyType,
        } = this.props;
        const dateTimeFormatted = DateUtils.getDateTimeSummary({
            startDateTimeObj: dayjs(starts),
            endDateTimeObj: dayjs(ends),
            isMonthly: false,
        });

        const diasbleBookNow = !selectedRate || selectedRate?.unavailable;

        return (
            <Card className="AirportPurchaseInformation">
                <div className="AirportPurchaseInformation-reservation-time">
                    <div className="title">
                        <h2 className="title-heading">
                            <span>Reservation Time</span>
                        </h2>
                        <Button
                            className="title-action"
                            onClick={this._onDateTimeEditClick}
                        >
                            Change
                        </Button>
                    </div>
                    <div className="preview-datetime">{dateTimeFormatted}</div>
                </div>
                <AvailableInventory
                    availableTransientInventory={availableTransientInventory}
                />
                {!diasbleBookNow && (
                    <div className="AirportPurchaseInformation-daily-price">
                        <span className="price-per-day">
                            <Price
                                amount={displayPrice}
                                currencyType={currencyType}
                            />{' '}
                            <span className="per-day">Per Day</span>
                        </span>
                        <small className="price-basis">
                            Price is based on a 24 hour period
                        </small>
                    </div>
                )}
                <Button
                    className="AirportPurchaseInformation-book-now"
                    color="primary"
                    disabled={diasbleBookNow}
                    onClick={onCheckoutClick}
                    block
                >
                    Book Now
                </Button>
                <PaymentMethodsIcons
                    showAlternatePaymentOptions
                    alignment="center"
                />
                <Box textAlign="center" marginTop={2}>
                    <CancellationInfo
                        cancellationAllowed={cancellationAllowed}
                        showFreeCancellation
                    />
                </Box>
            </Card>
        );
    }
}
